import { useMemo } from 'react'
import axios from '@fs/zion-axios'
import { useTranslation } from 'react-i18next'
import useFetchData from './useFetchData'
import getStdLocale from './getStdLocale'

const WHITELIST = [
  1, // USA
  133, // Canada
]

const initialData = []

async function fetchStates({ countryId, stdLocale }) {
  if (!countryId || !WHITELIST.includes(countryId)) {
    return initialData
  }
  const { data } = await axios.get(`/service/standards/place/ws/places/reps/${countryId}`, {
    params: { children: 'true', filterAttributes: 'true' },
  })
  const allStates = data.rep.children.filter((e) => {
    const isNotHistorical = !e.toYear
    const isStateOrDistrict = e.type.code === 'STATE' || e.type.code === 'DISTRICT' || e.type.code === 'PROVINCE'
    return isNotHistorical && isStateOrDistrict
  })
  return allStates.map((x) => {
    const localName = x.displayNames.find((s) => {
      return s.locale === stdLocale
    })
    return { key: x.id, value: `${x.id}`, label: localName?.name || x.display.name }
  })
}

export default function useStateOptions(countryId) {
  const { i18n } = useTranslation()
  const requestFnArg = useMemo(
    () => ({ countryId, stdLocale: getStdLocale(i18n.language) }),
    [countryId, i18n.language]
  )
  const { data: stateOptions, loading: stateOptionsLoading } = useFetchData(fetchStates, {
    initialData,
    requestFnArg,
  })
  return { stateOptions, stateOptionsLoading }
}
